import { ShowDataState } from '@store/shows/show.firestore.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { FIRESTORE_COLLECTION_SHOWS } from '@store/firestore/allFirestoreCollections';

export const showDataState = createFeatureSelector<ShowDataState>(FIRESTORE_COLLECTION_SHOWS);
